// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2u2rI","clinicsSelect":"TableHeading_clinicsSelect__RCwAn"};